'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';

interface LinkItem {
  href: string;
  name: string;
}

interface SidebarProps {
  links: LinkItem[];
}

export const Sidebar: React.FC<SidebarProps> = ({ links }) => {
  const [isOpen, setIsOpen] = useState(false);
  const pathname = usePathname();

  return (
    <>
      {/* Mobile Hamburger Button */}
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="lg:hidden absolute left-4 top-40 z-50 p-2 rounded-md text-gray-700"
        aria-expanded={isOpen}
        aria-label="Toggle sidebar"
      >
        {!isOpen ? (
          <FontAwesomeIcon icon={faBars} className="h-5 w-5" />
        ) : (
          ""
          // <FontAwesomeIcon icon={faTimes} className="h-5 w-5" />
        )}
      </button>

      {/* Sidebar Container */}
      <aside className={`${isOpen ? 'translate-x-0' : '-translate-x-full'} 
        lg:translate-x-0 fixed lg:static inset-y-0 left-0 w-[50%] lg:w-full h-[40%] pt-2 bg-white lg:bg-transparent 
        shadow-lg lg:shadow-none z-40 transition-transform duration-300 ease-in-out mt-44 lg:mt-0`}
      >
        <nav className='pt-5 md:pt-0'>
          <ul className='border-b border-[#D7D7D7]'>
            {links.map((link) => (
              <li key={link.href} className="">
                <Link
                  href={link.href}
                  className={`block py-2 px-2 text-xs md:text-lg text-[#333840] transition duration-200 border-t-1 border-[#D7D7D7] ${
                    pathname === link.href ? 'bg-[#002B4E] text-white' : 'bg-white hover:bg-[#F2F7FF]'
                  }`}
                  onClick={() => setIsOpen(false)}
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </aside>

      {/* Overlay for mobile */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black opacity-20 lg:hidden z-30"
          onClick={() => setIsOpen(false)}
        />
      )}
    </>
  );
};